import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

const CALENDAR_DATE_FORMAT = 'DD/MM/YYYY';
const EMPTY_DATE = '';

@Pipe({name: 'utcCalendarDate'})
export class UtcCalendarDatePipe implements PipeTransform {
  transform(timestamp: string | number): string {
    return timestamp ? moment.utc(timestamp).format(CALENDAR_DATE_FORMAT) : EMPTY_DATE;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/pipes/utc-calendar-date.pipe.ts